import React,{useEffect, useState} from 'react';
import AmbassadorHeader from '../../components/common/AmbassadorHeader';
import Logo from '../../components/common/Logo';
import SidebarMenu from '../../components/ambassador/SidebarMenu';
import { Link, useNavigate } from "react-router-dom";
import StudentTable from '../../components/ambassador/StudentTable';
import AddNewStudentForm from '../../components/ambassador/AddNewStudentForm';
import { getAmbassadorDetail} from '../../actions/AmbassadorActions';
import InMobileSideMenu from '../../components/ambassador/InMobileSideMenu';

 const AddNewStudent=(props)=>{
   const navigate = useNavigate();
   const [profileDetail, setProfileDetail] = useState({});

    
   useEffect(async() => {
      sessionStorage.getItem("ambDetail")
      ? navigate("/ambassador/add-new-student")
      : navigate("/ambassador/login");

      await getAmbassadorDetail()
      .then((res) => {
         setProfileDetail(res.data)
      })

   },[])
 

    return (
    <>

      <div className='mainAmb_wrapper'>
      {/* Sidebar */}
      <div className={`sidebar_contain`}>
       
            <Logo alt="Logo"/>
            <div className='sidebar_menu_contains'>
               <SidebarMenu detail={profileDetail}/>
            </div>

      </div>

      <div className='mobile_sideMenuWrap d-block d-lg-none'>
         <InMobileSideMenu detail={profileDetail}/>
      </div>
      
      <div className='main_contentAmb'>
      {/* Header */}
      <div className='headerAmb_contain'>
      <AmbassadorHeader detail={profileDetail}/>
      </div>
      <div className='amb_content'>
         <div className='container'>
            <div className='row  mt-3'>
                <div className='col-lg-12'>
                    <h2 className='h5 fw-bold'>Add New Student</h2>
                </div>
            </div>
            <div className='row  mt-3'>
               <div className='col-lg-12'>
                  <div className='card shadow-sm'>
                     {/* <div className='card-header'>
                  
                     </div> */}
                     <div className='card-body px-4'>
                        <div className='row'>
                        <div className='col-lg-12'>
                            <AddNewStudentForm detail={profileDetail}/>
                        </div>
                        </div>
                        
                
                     </div>
                  </div>
               </div>
            </div>
         </div>
      
      </div>
      
      </div>


      </div>
      
    
    
    </>)
 }

 export default AddNewStudent;